// Module
var code = "<div class=\"flex-layout -items-center spacer-box -p-v-eq-10 text-style -brand-color\"> <h4 class=\"item -content text-style -h4\">[[title]]</h4> <svg class=\"item -content svg-icon transform-style [[{ '-flipY': !collapsed }]] transition-style\"> <use xlink:href=\"#svg-ArrowDown\"/> </svg> </div> ";
// Exports
export default code;